<template>
	<div class="sensitive-container">
        <div class="sensitive-search">
            <a-select class="width-160" v-model="klassId" placeholder="请选择所属班级"
                :allowClear="isManager" @change="initSensitiveHandle">
                <a-select-option v-for="item in klassList" :value="item.id" :key="item.id">
                    {{ item.name }}
                </a-select-option>
            </a-select>
        </div>
        <div class="sensitive-content">
            <div class="sensitive-post">
                <a-tabs v-model="sensitiveKey" v-if="sensitiveWord">
                    <a-tab-pane key="post" tab="班级圈">
                        <div class="sensitive-post_container" @mousewheel="sensitivePostScrollChange" ref="scrollContainer">
                            <ul ref="scrollEle">
                                <li v-for="item in sensitivePost" :key="item.id">
                                    <div class="sensitive-post_item">
                                        <div class="sensitive-post_item_content" v-html="computedText(item.content)"></div>
                                        <div class="sensitive-post_item_info">
                                            <span class="m-right-10">{{item.create_time | timeFormat("YYYY-MM-DD")}}</span>
                                            <span class="m-right-10">{{ item.author.name }}</span>
                                            <span>{{ item.klass.name }}</span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <a-divider v-if="!hasMoreSensitivePost && sensitivePost.length" class="sensitive-post_divider">已展示全部数据</a-divider>
                            <a-empty  v-if="!hasMoreSensitivePost && !sensitivePost.length" class="p-top-10 p-bottom-10" description="暂无数据" />
                        </div>
                    </a-tab-pane>
                    <a-tab-pane key="album" tab="成长手册">
                        <div class="sensitive-post_container" @mousewheel="sensitiveAlbumScrollChange" ref="albumScrollContainer">
                            <ul ref="albumScrollEle">
                                <li v-for="item in sensitiveAlbum" :key="item.id">
                                    <div class="sensitive-post_item">
                                        <div class="sensitive-post_item_title">{{item.album_view.title}}</div>
                                        <div v-for="pageView in item.pageViews" :key="pageView.id">
                                            <div class="sensitive-post_item_page p-left-10">第 {{pageView.id}} 页</div>
                                            <div v-for="(fieldView, index) in pageView.fieldViews" :key="index" class="sensitive-post_item_content p-left-20" v-html="computedText(fieldView.value)"></div>
                                        </div>
                                        <div class="sensitive-post_item_info">
                                            <span class="m-right-10">{{item.album_view.create_time | timeFormat("YYYY-MM-DD")}}</span>
                                            <span class="m-right-10">{{ item.album_view.student.kid_name }}</span>
                                            <span>{{ item.album_view.klass.name }}</span>
                                        </div>                                    
                                    </div>
                                </li>
                            </ul>
                            <a-divider v-if="!hasMoreSensitiveAlbum && sensitiveAlbum.length" class="sensitive-post_divider">已展示全部数据</a-divider>
                            <a-empty  v-if="!hasMoreSensitiveAlbum && !sensitiveAlbum.length" class="p-top-10 p-bottom-10" description="暂无数据" />
                        </div>
                    </a-tab-pane>
                </a-tabs>
                
                <a-empty v-else class="p-top-10 p-bottom-10" description="请选择敏感词" />
            </div>

            <div class="sensitive-sider">
                <p class="sensitive-sider_title">
                    <span>敏感词列表</span>
                </p>
                <span
                    :class="['sensitive-word_item', { 'sensitive-word_item_selected': sensitiveWord && sensitiveWord.id === item.id }]"
                    v-for="item in sensitiveWordSource" :key="item.id"
                    @click="selectedSensitiveWordHandle(item)">
                    {{ item.content }}
                    <a-icon v-if="isManager" class="m-left-5" type="close"
                        @click.stop="delSensitiveWordHandle(item)" />
                </span>

				<a-button v-if="isManager" class="sensitive-sider_btn" icon="plus" type="primary" @click="showSensitiveWordModal">添加敏感词</a-button>
            </div>
        </div>

		<a-modal title="添加敏感词" v-model="sensitiveModalInfo.visible" :confirm-loading="sensitiveModalInfo.loading"
			@ok="createSensitiveWordHandle">
			<div class="sensitive-modal_item">
				<span class="sensitive-modal_label">新敏感词：</span>
				<a-input class="sensitive-modal_input" v-model="sensitiveModalInfo.content" placeholder="请输入敏感词内容" />
			</div>
		</a-modal>
	</div>
</template>
  
<script>
import SensitiveWordService from "@/api/sensitiveService";
import { mapGetters } from "vuex";

export default {
	name: "sensitive",
	components: {},
	data() {
		return {
			klassId: undefined,
			sensitivePost: [],
			sensitiveAlbum: [],
			sensitiveWord: undefined,
			sensitiveModalInfo: {
				visible: false,
				loading: false,
				content: undefined,
			},
			sensitiveWordSource: [],
			sensitiveKey: "post",
			sensitivePostId: undefined,
			sensitiveALbumId: undefined,
			hasMoreSensitivePost: true,
			hasMoreSensitiveAlbum: true,
			loadingSensitiveAlbum: false,
			loadingSensitivePost: false,
		};
	},

	computed: {
		...mapGetters(["isManager", "teacherInfo", "curKlassId", "klassList"]),
		computedText() {
			return function(content) {
				return content.replaceAll(
					this.sensitiveWord.content,
					`<i style='color:red;'>${this.sensitiveWord.content}</i>`
				);
			};
		},
	},

	created() {
		this.initHandle();
	},

	methods: {
		initHandle() {
			this.getKlassList(true);
		},

		getKlassList(isForce = false) {
			this.$store
				.dispatch("getKlassListService", { isForce })
				.then((res) => {
                    if (!this.isManager) {
                        this.klassId = res[0].id;
                    }
					this.getSensitiveWordList();
				});
		},

		initSensitiveHandle() {
			this.hasMoreSensitivePost = true;
			this.hasMoreSensitiveAlbum = true;
			this.loadingSensitiveAlbum = false;
			this.loadingSensitivePost = false;
			this.sensitiveAlbum = [];
			this.sensitivePost = [];
			this.sensitiveALbumId = undefined;
			this.sensitivePostId = undefined;
			this.getSensitiveWordPostSource();
			this.getSensitiveWordAlbumSource();
		},

		getSensitiveWordList() {
			SensitiveWordService.getSensitiveWordListService({
				school_id: this.teacherInfo.school_id,
			}).then((res) => {
				this.sensitiveWordSource = res;
			});
		},

		getSensitiveWordPostSource() {
			if (!this.hasMoreSensitivePost) return;
			if (this.loadingSensitivePost) return;
			this.loadingSensitivePost = true;
			SensitiveWordService.getSensitiveWordPostListService({
				id: this.sensitiveWord.id,
				klass_id: this.klassId,
				limit: 20,
				after_id: this.sensitivePostId,
			})
				.then((res) => {
					this.loadingSensitivePost = false;
					this.sensitivePost = [
						...this.sensitivePost,
						...res,
					];
					if (res.length === 20) {
						this.sensitivePostId = res[res.length - 1].id;
					} else {
						this.hasMoreSensitivePost = false;
					}
				})
				.catch(() => {
					this.loadingSensitivePost = false;
				});
		},

		getSensitiveWordAlbumSource() {
			if (!this.hasMoreSensitiveAlbum) return;
			if (this.loadingSensitiveAlbum) return;
			this.loadingSensitiveAlbum = true;
			SensitiveWordService.getSensitiveWordAlbumListService({
				id: this.sensitiveWord.id,
				klass_id: this.klassId,
				limit: 20,
				after_id: this.sensitiveAlbumId,
			})
				.then((res = []) => {
					this.loadingSensitiveAlbum = false;
					res.forEach((album) => {
                        const pageViews = [];
						album.page_views.forEach((item) => {
                            const pageView = { id: item.id, fieldViews: [] };
							for (
								let i = 0;
								i < item.section_views.length;
								i++
							) {
								for (
									let j = 0;
									j <
									item.section_views[i].field_views.length;
									j++
								) {
									const fieldView =
										item.section_views[i].field_views[j];
									if (
										fieldView.type === "text" &&
										fieldView.value &&
										fieldView.value.indexOf(
											this.sensitiveWord.content
										) > -1
									) {
                                        pageView.fieldViews.push(fieldView);
										continue;
									}
								}
							}

                            if (pageView.fieldViews.length) {
                                pageViews.push(pageView);
                            }
						});
						album.pageViews = pageViews;
					});

					this.sensitiveAlbum = [
						...this.sensitiveAlbum,
						...res,
					];

					if (res.length === 20) {
						this.sensitivePostId = res[res.length - 1].id;
					} else {
						this.hasMoreSensitiveAlbum = false;
					}
				})
				.catch(() => {
					this.loadingSensitiveAlbum = false;
				});
		},

		selectedSensitiveWordHandle(sensitiveWord) {
			this.sensitiveWord = sensitiveWord;
			this.initSensitiveHandle();
		},

		showSensitiveWordModal() {
			Object.assign(this.sensitiveModalInfo, {
				visible: true,
				loading: false,
				content: undefined,
			});
		},

		createSensitiveWordHandle() {
			if (
				!this.sensitiveModalInfo.content ||
				!this.sensitiveModalInfo.content.trim().length
			) {
				this.$message.warning("敏感词内容不可为空");
				return;
			}
			this.sensitiveModalInfo.loading = true;
			SensitiveWordService.createSensitiveWordService({
				content: this.sensitiveModalInfo.content.trim(),
				school_id: this.teacherInfo.school_id,
			})
				.then(() => {
					this.$message.success("添加成功!");
					this.getSensitiveWordList();
					this.sensitiveModalInfo.visible = false;
				})
				.catch(() => {
					this.sensitiveModalInfo.loading = false;
					this.$message.success("操作失败，请检查后重试");
				});
		},

		delSensitiveWordHandle(sensitiveWord) {
			this.$confirm({
				title: "提示信息",
				content: `是否删除当前敏感词 ${sensitiveWord.content}`,
				okText: "确定",
				cancelText: "取消",
				onOk: () => {
					return new Promise((resolve, reject) => {
						SensitiveWordService.delSensitiveWordService({
							id: sensitiveWord.id,
						})
							.then(() => {
								this.$message.success("操作成功");
								if (
									this.sensitiveWord && this.sensitiveWord.id === sensitiveWord.id
								) {
									this.sensitiveWord = undefined;
								}
								this.getSensitiveWordList();
								resolve();
							})
							.catch(() => {
								reject();
								this.$message.error("操作失败，请重新操作");
							});
					});
				},
			});
		},

		sensitiveAlbumScrollChange() {
			const containerH = this.$refs.albumScrollContainer.offsetHeight;
			const contentH = this.$refs.albumScrollEle.offsetHeight;
			const scrollTop = this.$refs.albumScrollEle.scrollTop;

			if (contentH - containerH - scrollTop < 100) {
				this.getSensitiveWordPostSource();
			}
		},

		sensitivePostScrollChange() {
			const containerH = this.$refs.scrollContainer.offsetHeight;
			const contentH = this.$refs.scrollEle.offsetHeight;
			const scrollTop = this.$refs.scrollContainer.scrollTop;
			if (contentH - containerH - scrollTop < 100) {
				this.getSensitiveWordPostSource();
			}
		},
	},
};
</script>
  
<style lang="less" scoped>
.sensitive {
	&-container {
		background: #ffffff;
		min-height: calc(100% - 65px);
		margin-top: 15px;
		padding: 28px 28px 2px 30px;
	}

	&-content {
		display: flex;
		flex-flow: nowrap row;
	}

	&-search {
		margin-bottom: 20px;
	}

	&-modal {
		&_item {
			display: flex;
			flex-flow: nowrap row;
			justify-content: space-between;
			align-items: center;
		}

		&_label {
			width: 100px;
		}

		&_inpit {
			width: 200px;
			flex-grow: 1;
		}
	}

	&-word {
		&_item {
			display: inline-block;
			min-width: 88px;
			height: 35px;
			padding: 0 15px;
			margin: 0 20px 20px 0;
			line-height: 33px;
			text-align: center;
			border-radius: 20px;
			background: #ffffff;
			border: 1px solid #409eff;
			font-size: 14px;
			color: #409eff;
			cursor: pointer;

			&_selected {
				background: #409eff;
				color: #ffffff;
			}
		}
	}

	&-sider {
		width: 330px;
		margin-left: 20px;
		padding: 0 26px;
		border-left: 1px solid #d9d9d9;

		&_title {
			margin-left: 5px;
			font-size: 14px;
			font-weight: bold;
			color: #3d3d3d;

			&::before {
				position: relative;
				top: 0px;
				display: inline-block;
				content: "";
				width: 6px;
				height: 6px;
				margin-right: 13px;
				background: #409eff;
				border-radius: 50%;
			}
		}

		&_btn {
			display: block;
			width: 160px;
			margin: 100px auto 50px;
		}
	}

	&-post {
		width: 770px;
		// flex-grow: 1;
		&_container {
			width: calc(100% + 18px);
			height: calc(100vh - 285px);
			overflow-y: auto;
		}
		&_item {
            display: inline-block;
            min-width: 350px;
			margin-bottom: 20px;
            padding-left: 16px;
			padding-bottom: 8px;
			list-style: none;
			// border-bottom: 1px solid #e8e8e8;
			color: #8590a6;
			font-size: 12px;
			&_title {
				margin-bottom: 5px;
				font-size: 14px;
				font-weight: bold;
				color: #597ab2;
			}
            &_page {
				margin-top: 4px;
				font-size: 14px;
                font-weight: 500;
				color: #333333;
                // padding-left: 10px;
            }
			&_content {
				margin-top: 4px;
                // padding-left: 20px;
				font-size: 14px;
				color: #333333;
			}
            &_info {
                margin-top: 8px;
            }
		}
        &_divider {
            margin: 20px 0 !important;
            font-size: 12px !important;
            color: #cccccc !important;
        }
	}
}
</style>
